module.exports = __webpack_public_path__ + "static/img/hd-i1.3043a35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/hd-i1.png
// module id = Ps83
// module chunks = 1